export default __webpack_public_path__ + "static/media/pngIcon.b02b3a45.svg";